import { ButtonType, ButtonWidget, TextFieldWidget } from '@tableau/widgets';
import React = require('react');
import { LoginUrlsWrapper } from '~src/app/spaces/Login/LoginUrls';
import { SignInLogo } from '~src/app/spaces/Login/SignInLogo';
import { Messages } from '~src/codegen/Localize';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { ServerSettingsUnauthenticated } from '~src/settings/services/ServerSettingsUnauthenticated';
import { GeneratePasswordResetTokenRequest, IGeneratePasswordResetTokenParams } from '~src/ts/ServerApi/requests/GeneratePasswordResetTokenRequest';
import { PasswordResetForm } from './PasswordResetForm';

export function PasswordResetPage() {
    const [showPasswordResetForm , setShowPasswordResetForm ] = React.useState(true);

    if (!ServerSettingsUnauthenticated.isPasswordResetEnabled()) {
        LoginUrlsWrapper.navigateToSignIn({});
        //this is just in case to make sure 
        return null;
    }
    if (showPasswordResetForm) {
        return <PasswordResetForm
        onSubmit={() => setShowPasswordResetForm(false)} />;
    }
    else {
        return (
            <div className='tb-login'>
                <span className='tb-login-form-container' >
                    <SignInLogo />
                    <div className='tb-password-reset-msg'>
                        <div className='tb-login-msg tb-password-reset-success'>
                            <div>{Messages.passwordResetSuccess()}</div>
                            <div className='tb-restart-password-reset'>
                                <span>{Messages.unreceivedPasswordResetEmail()}</span>
                                <ButtonWidget buttonType={ButtonType.Outline}
                                    testId='resendPasswordReset'
                                    onClick={() => setShowPasswordResetForm(true)}
                                    title={Messages.requestPasswordResetAgain()}
                                >
                                    {Messages.requestPasswordResetAgain()}
                                </ButtonWidget>
                            </div>
                        </div>
                    </div>
                </span>
            </div>
        );
    }
}